import React, { Component } from 'react';

import {
    WithStyles, createStyles, Button, Typography, Grid, IconButton, Popover, Tooltip
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { MyPatVideoPlayer, MyPATTextField } from '../../../../common';
import ReactPlayer from 'react-player';
import contentService from '../../../services/contentService';
import { videoActions } from '../../../reducers/videoCreateContentReducers';
import { showMsg } from '../../../../course/actions/loaderAlert';
import videoUploadService from '../../../services/videoUploadService';
import axios from "axios";
import { CONTENT_STATES, VIDEO_UPLOAD_MODES } from '../../../../../constants/comman';

const styles = (theme: Theme) => createStyles({
    videoAlignment: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        "&>div:nth-of-typpe(1)": {
            marginRight: "auto !important",
          },
    },
    button: {
        margin: theme.spacing.unit,
    },
    addQuestionTitle: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'Nunito',
    },
    marginTopminus: {
        marginTop: '-8px',
    },
    padBotNew: {
        paddingBottom: '30px',
    },
});

const filterContent: any = {
    contentFilterData: [{
        filterValue: 'contentType',
        isSelected: true,
        filters: [{
            filterValue: 'studymaterial',
            isSelected: true,
            filters: [
                {
                    filterValue: 'videos',
                    isSelected: true,
                    filters: []
                }
            ]
        }
        ]
    },
    {
        filterValue: 'status',
        isSelected: true,
        filters: [{
            filterValue: CONTENT_STATES.PUBLISHED,
            isSelected: true,
            filters: []
        }],
    }
    ]
}

interface VideoUrlUploadDialogProps extends WithStyles<typeof styles> {
    classes: any;
    onDialogClose: Function;
    videoUrl: string;
    createVideoContent: Function;
    handleURL: Function;
    showMsg: Function;
    mode: string;
    addVideoDetails: Function;
    videoDetails: any;
    resetVideoModalState: Function;
    videoId?: any;
    deleteVideo: Function;
}

interface VideoUrlUploadDialogState {
    isValidUrl: boolean;
    urlUpoadFinished: boolean;
}

class VideoUrlUploadDialog extends Component<VideoUrlUploadDialogProps, VideoUrlUploadDialogState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isValidUrl: false,
            urlUpoadFinished: false,
        }
    }

    componentDidMount = async () => {
        const { videoUrl, addVideoDetails, videoId } = this.props;
        const source = axios.CancelToken.source();
        if (videoUrl.startsWith('V-') || videoUrl.startsWith('v-')) {
            try {
                const response: any = await contentService.list({
                    searchText: videoUrl.toUpperCase(), ...filterContent
                }, 1, 50)
                const videoUri = response[0].videoUrl;
                const result = await videoUploadService.getHlsUrl(videoUri);
                if (!result.length) throw new Error();
                this.setState({
                    isValidUrl: true
                }, () => this.props.handleURL(result));
            } catch (error) {
                this.props.showMsg('Either content Id is not valid or it is a draft content.', 'error');
                this.props.resetVideoModalState();
            }
        } else {
            const isValidUrl = ReactPlayer.canPlay(videoUrl);
            if (isValidUrl) {
                addVideoDetails({
                    source
                });
                videoUploadService.uploadUrl(videoUrl, source.token, videoId).then((response: any) => {
                    this.setState({
                        isValidUrl: true,
                        urlUpoadFinished: true
                    }, () => this.props.handleURL(response))
                })
                    .catch((err: any) => {
                        if (axios.isCancel(err)) {
                            this.props.showMsg('Video upload cancelled', 'error');
                        }
                        this.props.resetVideoModalState();
                    })
            } else {
                this.props.showMsg('Invalid url', 'error');
                this.props.resetVideoModalState();
            }
        }
    }

    cancelUpload = () => {
        const { videoDetails, videoUrl } = this.props;
        const { isValidUrl, urlUpoadFinished } = this.state;
        if (videoUrl.length && isValidUrl && urlUpoadFinished) {
            this.props.deleteVideo(videoUrl);
        } else if (typeof videoDetails.source.cancel === 'function'){
            videoDetails.source.cancel();
            this.props.resetVideoModalState();
        } else {
            this.props.resetVideoModalState();
        }
    }

    render() {
        const {
            classes,
            onDialogClose,
            videoUrl,
            createVideoContent,
            mode
        } = this.props;
        const { isValidUrl } = this.state;

        return (
            <>
                <MyPatVideoPlayer width="322px" height="181px" videoURL={videoUrl} controls={true} />
                <Grid container>
                    <Grid item sm ></Grid>
                    {mode === VIDEO_UPLOAD_MODES.EDIT ? '' : <Grid item>
                        <Button
                            className={classes.button}
                            color="primary"
                            onClick={() => onDialogClose()}
                        >
                            Cancel
						</Button>
                    </Grid>}
                    <Grid item>
                        <Button
                            disabled={!(videoUrl.length && isValidUrl)}
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={() => createVideoContent(videoUrl)}
                        >
                            Submit
						</Button>
                    </Grid>
                </Grid>
            </>
        )


    }
}

const mapStateToProps = (state: any) => {
    return {
        videoUrl: state.videoCreateContent.videoURL,
        videoDetails: state.videoCreateContent.videoDetails,
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    handleURL: videoActions.videoUrlChanged,
    showMsg: showMsg,
    addVideoDetails: videoActions.addVideoDetails,
    resetVideoModalState: videoActions.resetVideoModalState
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VideoUrlUploadDialog));